<div class="widget" *transloco="let t; read: 'dashboard'">
  <h2>{{t('candidatesWidgetTitle') | capitalize}}</h2>
  <app-candidate-list [candidatesListing]="candidates"></app-candidate-list>
  <ng-container *ngIf="candidates.length">
    <app-no-results *ngIf="candidates[0].items.length === 0"></app-no-results>
  </ng-container>
</div>
